import { ComponentType } from '@wix/a11y-adapters';
import { useCallback } from 'react';
import { useGlobalSectionState } from '../rule-mappers/shared/use-global-section-state';
import { useVerify } from '../rule-mappers/shared/use-verify';
import { getCompRefType } from '../utils/get-comp-ref-type';
import { isEditor3Host } from '../utils/get-editor-host';
import { usePanelStateAtom } from './rules-state';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
export function useGenericElement(_ref) {
  let {
    pageId,
    getComponentStyleSource,
    unknownValue
  } = _ref;
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const {
    getGlobalSectionModifiedComponentIds
  } = useGlobalSectionState();
  const {
    verify
  } = useVerify({});
  const {
    getGroupData,
    panelState
  } = usePanelStateAtom();
  const {
    getIsComponentInGlobalSection
  } = useGlobalSectionState();
  const getComponent = useCallback(id => {
    const component = a11yWizardAdapter.getComponent({
      id,
      type: getCompRefType(editorHost)
    });
    if (!component) {
      throw new Error(`Component with id ${id} not found`);
    }
    return component;
  }, [a11yWizardAdapter, editorHost]);
  const isGenericElement = useCallback((elementId, className) => {
    var _component, _component2, _component3, _component4;
    let component;
    try {
      component = getComponent(elementId);
    } catch (e) {
      console.error(e);
    }
    const compRef = {
      id: elementId,
      type: getCompRefType(editorHost)
    };
    if (isEditor3Host(editorHost) && a11yWizardAdapter.isBuilderComponent(compRef)) {
      return !(a11yWizardAdapter.isBuilderRichTextComponent != null && a11yWizardAdapter.isBuilderRichTextComponent(compRef)) && Boolean(className) && a11yWizardAdapter.isGenericBackgroundColorContrastBuilderComponent(compRef, className ?? '') || a11yWizardAdapter.isGenericForegroundColorContrastBuilderComponent(compRef, className ?? '');
    }
    if (((_component = component) == null ? void 0 : _component.type) === ComponentType.StylableButton && !!((_component2 = component) != null && (_component2 = _component2.style) != null && (_component2 = _component2.style) != null && _component2.properties && '$st-css' in component.style.style.properties)) {
      return true;
    }
    return !((_component3 = component) != null && _component3.type) || getComponentStyleSource((_component4 = component) == null ? void 0 : _component4.type) === unknownValue;
  }, [a11yWizardAdapter, editorHost, getComponent, getComponentStyleSource, unknownValue]);
  const handleRescanClick = useCallback(async componentId => {
    const groupData = getGroupData(pageId);
    if (!groupData) {
      throw new Error(`Group data not found for pageId: ${pageId}.`);
    }
    const isComponentInGlobalSection = getIsComponentInGlobalSection(componentId);
    await verify(groupData, [...getGlobalSectionModifiedComponentIds(panelState.globalSectionComponentsDataMap), ...(isComponentInGlobalSection ? [componentId] : [])]);
  }, [getIsComponentInGlobalSection, getGlobalSectionModifiedComponentIds, getGroupData, pageId, panelState.globalSectionComponentsDataMap, verify]);
  return {
    getComponent,
    handleRescanClick,
    isGenericElement
  };
}
//# sourceMappingURL=use-generic-element.js.map